import React from 'react';
import { Amplify } from 'aws-amplify';
import { Header } from './components/Header';
import { LandingPage } from './components/LandingPage';
import './styles/main.css';
import awsconfig from './aws-exports';

Amplify.configure(awsconfig);

const App: React.FC = () => {
  const [activeSource, setActiveSource] = React.useState<'arxiv' | 'crossref'>('arxiv');

  return (
    <div className="App">
      <Header activeSource={activeSource} onSourceChange={setActiveSource} />
      <main className="main-content">
        <LandingPage source={activeSource} />
      </main>
      <footer className="footer">
        <p>&copy; 2025 Research Blog. Powered by ArXiv, CrossRef and AWS Amplify.</p>
      </footer>
    </div>
  );
};

export default App;